import request from "@/utils/request";

//查看专刊
export function search_monograph(data) {
    return request({
        url: "/search_monograph",
        method: "post",
        data: data,
    });
}

// 修改专刊
export function update_monograph(data) {
    return request({
        url: "/update_monograph",
        method: "post",
        data: data,
    });
}

// 添加专刊
export function add_monograph(data) {
    return request({
        url: "/add_monograph",
        method: "post",
        data: data,
    });
}

// 删除专刊
export function delete_monograph(data) {
    return request({
        url: "/delete_monograph",
        method: "post",
        data: data,
    });
}

// 期刊名称搜索
export function search_journal_name(data) {
    return request({
        url: "/search_journal_name",
        method: "post",
        data: data,
    });
}